import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const driftwood: ThemeDefinition = {
  label: "Driftwood",
  className: "theme-driftwood",
  bg: "#ece4d8",
  text: "#4a3828",
  textMuted: `color-mix(in srgb, #4a3828 60%, transparent)`,
  accent: "#b87048",
  glassRgb: "236,228,216",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #4a3828 30%, transparent)`,
  selection: "#4a3828",
  selectionText: "#ffffff",
  gridColor: "#d8ccb8",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(30,20,10,0.18)",
  gpuClear: hexToSrgb("#ece4d8"),
  gpuGridLine: hexToLinear("#d8ccb8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#b87048"),
  gpuAxisZ: hexToLinear("#4a3828"),
  axisXColor: "#b87048",
  axisZColor: "#4a3828",
  font: '"Libre Baskerville", serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
};
